export default __webpack_public_path__ + "static/media/face-with-rolling-eyes.cb9c4b59.png";